var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOccasionTaufeLow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1024,
    height: 1024,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 1024,
    height: 1024,
    fill: "#7f6b51"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "scale(4.000000) translate(0.5 0.5)"
  }, /*#__PURE__*/React.createElement("polygon", {
    fill: "#ebc9b4",
    fillOpacity: 0.501961,
    points: "128,188 271,94 166,-1"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#0d0600",
    fillOpacity: 0.501961,
    points: "-16,251 192,271 54,140"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#f1ce8f",
    fillOpacity: 0.501961,
    points: "26,157 181,-16 67,2"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#000000",
    fillOpacity: 0.501961,
    points: "202,256 254,111 261,271"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#ffffef",
    fillOpacity: 0.501961,
    points: "101,163 107,104 36,98"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#1a0200",
    fillOpacity: 0.501961,
    points: "118,41 186,38 102,115"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#080d00",
    fillOpacity: 0.501961,
    points: "76,52 25,0 41,75"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#120600",
    fillOpacity: 0.501961,
    points: "105,271 144,192 53,156"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#272105",
    fillOpacity: 0.501961,
    points: "35,171 -16,247 -1,76"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#e6e1bd",
    fillOpacity: 0.501961,
    points: "50,150 28,98 42,208"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#000000",
    fillOpacity: 0.501961,
    points: "177,186 246,203 178,159"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#ffc6b9",
    fillOpacity: 0.501961,
    points: "139,197 176,183 238,210"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#ecb8af",
    fillOpacity: 0.501961,
    points: "214,196 165,250 200,271"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#0d0b00",
    fillOpacity: 0.501961,
    points: "201,130 217,173 271,166"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#000000",
    fillOpacity: 0.501961,
    points: "197,29 220,-16 230,20"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#b5a995",
    fillOpacity: 0.501961,
    points: "163,199 271,17 203,31"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#2b3412",
    fillOpacity: 0.501961,
    points: "89,100 35,67 16,95"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#310300",
    fillOpacity: 0.501961,
    points: "198,105 197,74 178,47"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#ffe7bf",
    fillOpacity: 0.501961,
    points: "109,9 82,2 96,93"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#e6af93",
    fillOpacity: 0.501961,
    points: "134,85 141,227 181,57"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#10160d",
    fillOpacity: 0.501961,
    points: "-1,46 20,67 18,-16"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#ffdba6",
    fillOpacity: 0.501961,
    points: "147,9 186,43 124,28"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#e7f1ea",
    fillOpacity: 0.501961,
    points: "31,112 55,71 37,146"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#e7d0cf",
    fillOpacity: 0.501961,
    points: "208,184 218,175 250,194"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#645c0d",
    fillOpacity: 0.501961,
    points: "77,167 49,93 42,158"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#975907",
    fillOpacity: 0.501961,
    points: "94,14 203,5 121,-16"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#928662",
    fillOpacity: 0.501961,
    points: "54,270 50,190 26,194"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#3b1912",
    fillOpacity: 0.501961,
    points: "121,261 157,207 204,199"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#eac0a3",
    fillOpacity: 0.501961,
    points: "198,164 128,157 222,94"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#73461d",
    fillOpacity: 0.501961,
    points: "82,170 162,112 100,214"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#bdb596",
    fillOpacity: 0.501961,
    points: "18,93 40,40 -5,83"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#0e0000",
    fillOpacity: 0.501961,
    points: "139,96 165,98 159,88"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#362306",
    fillOpacity: 0.501961,
    points: "191,65 125,39 173,38"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#000000",
    fillOpacity: 0.501961,
    points: "165,161 149,182 169,185"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#ede0bc",
    fillOpacity: 0.501961,
    points: "66,104 104,100 89,169"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#080301",
    fillOpacity: 0.501961,
    points: "212,207 202,271 253,258"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#e6c99d",
    fillOpacity: 0.501961,
    points: "51,44 63,2 80,40"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#5b4924",
    fillOpacity: 0.501961,
    points: "86,37 92,99 68,44"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#e6bbb7",
    fillOpacity: 0.501961,
    points: "197,271 166,242 165,215"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#0a1015",
    fillOpacity: 0.501961,
    points: "180,241 203,249 172,222"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#b19838",
    fillOpacity: 0.501961,
    points: "69,166 93,171 65,102"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#989786",
    fillOpacity: 0.501961,
    points: "271,56 148,-6 237,143"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#f8ccb9",
    fillOpacity: 0.501961,
    points: "161,194 142,227 135,216"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#fbcab0",
    fillOpacity: 0.501961,
    points: "156,58 188,69 173,126"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#623e18",
    fillOpacity: 0.501961,
    points: "180,87 215,96 171,99"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#080909",
    fillOpacity: 0.501961,
    points: "220,174 195,193 169,168"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#dfd8c3",
    fillOpacity: 0.501961,
    points: "81,92 49,64 79,59"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#b57a56",
    fillOpacity: 0.501961,
    points: "199,112 139,122 215,143"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#3b2d0e",
    fillOpacity: 0.501961,
    points: "-16,-12 57,55 55,15"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#251809",
    fillOpacity: 0.501961,
    points: "73,271 109,160 139,203"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#f8d7d0",
    fillOpacity: 0.501961,
    points: "166,205 188,195 168,172"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#461a00",
    fillOpacity: 0.501961,
    points: "134,10 141,-12 140,31"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#f1cbc0",
    fillOpacity: 0.501961,
    points: "192,198 224,198 224,211"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#dca467",
    fillOpacity: 0.501961,
    points: "139,-12 96,37 106,85"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#dd7e56",
    fillOpacity: 0.501961,
    points: "73,194 55,212 62,184"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#c7c4b0",
    fillOpacity: 0.501961,
    points: "37,41 33,65 13,37"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#f2ffff",
    fillOpacity: 0.501961,
    points: "200,100 205,124 221,107"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#000000",
    fillOpacity: 0.501961,
    points: "164,263 162,211 147,268"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#51330f",
    fillOpacity: 0.501961,
    points: "99,88 164,42 113,125"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#cd824b",
    fillOpacity: 0.501961,
    points: "110,134 136,79 147,133"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#f1e5bc",
    fillOpacity: 0.501961,
    points: "42,177 52,169 36,151"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#231f0e",
    fillOpacity: 0.501961,
    points: "-16,126 31,131 24,111"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#e8cbbe",
    fillOpacity: 0.501961,
    points: "132,155 147,183 185,109"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#d77013",
    fillOpacity: 0.501961,
    points: "91,18 73,-16 78,30"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#d0d0c5",
    fillOpacity: 0.501961,
    points: "111,74 91,82 107,17"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#a87d59",
    fillOpacity: 0.501961,
    points: "129,187 108,130 162,203"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#fed2bd",
    fillOpacity: 0.501961,
    points: "197,222 213,203 202,245"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#231b10",
    fillOpacity: 0.501961,
    points: "46,49 21,99 37,104"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#0b0600",
    fillOpacity: 0.501961,
    points: "222,24 195,-11 234,-16"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#252214",
    fillOpacity: 0.501961,
    points: "92,80 89,102 78,93"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#393300",
    fillOpacity: 0.501961,
    points: "44,131 47,161 70,126"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#ded8c6",
    fillOpacity: 0.501961,
    points: "110,127 41,123 103,101"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#19240d",
    fillOpacity: 0.501961,
    points: "74,181 23,195 64,157"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#a99671",
    fillOpacity: 0.501961,
    points: "23,135 -16,131 7,146"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#8c8475",
    fillOpacity: 0.501961,
    points: "225,140 271,14 229,-8"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#a47b46",
    fillOpacity: 0.501961,
    points: "112,149 127,128 85,135"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#000000",
    fillOpacity: 0.501961,
    points: "243,191 271,206 207,195"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#8c6d54",
    fillOpacity: 0.501961,
    points: "86,267 67,229 35,228"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#241a03",
    fillOpacity: 0.501961,
    points: "203,153 204,132 258,168"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#7c6b48",
    fillOpacity: 0.501961,
    points: "206,151 190,167 267,199"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#da8023",
    fillOpacity: 0.501961,
    points: "127,48 127,21 87,-16"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#ffebe1",
    fillOpacity: 0.501961,
    points: "163,137 179,159 162,163"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#eea44c",
    fillOpacity: 0.501961,
    points: "140,-9 168,-11 158,31"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#cbc898",
    fillOpacity: 0.501961,
    points: "28,180 17,175 26,169"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#0e0700",
    fillOpacity: 0.501961,
    points: "-16,161 -7,201 19,173"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#000000",
    fillOpacity: 0.501961,
    points: "110,250 68,188 85,173"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#170e00",
    fillOpacity: 0.501961,
    points: "49,12 73,-13 46,-12"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#261d15",
    fillOpacity: 0.501961,
    points: "133,271 79,250 136,187"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#372a15",
    fillOpacity: 0.501961,
    points: "108,61 180,53 138,32"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#fdc3aa",
    fillOpacity: 0.501961,
    points: "189,102 194,119 133,110"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#694931",
    fillOpacity: 0.501961,
    points: "271,210 226,199 217,233"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#eef1e3",
    fillOpacity: 0.501961,
    points: "252,95 247,112 240,92"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#eed9d9",
    fillOpacity: 0.501961,
    points: "170,166 179,160 169,190"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#564225",
    fillOpacity: 0.501961,
    points: "176,-15 196,3 162,14"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#ffb843",
    fillOpacity: 0.501961,
    points: "61,138 57,144 78,152"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#f1b90a",
    fillOpacity: 0.501961,
    points: "65,79 72,91 49,78"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#fffde2",
    fillOpacity: 0.501961,
    points: "86,29 96,36 95,-7"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#776246",
    fillOpacity: 0.501961,
    points: "132,214 115,229 117,208"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#ac9e88",
    fillOpacity: 0.501961,
    points: "208,3 182,46 155,15"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#11100d",
    fillOpacity: 0.501961,
    points: "199,167 230,200 184,188"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOccasionTaufeLow);
export default __webpack_public_path__ + "static/media/occasion_taufe_low.f0c115765e809298d27a1dc999cecee9.svg";
export { ForwardRef as ReactComponent };